import Locations from '../locations';
import { ActionTypes, CityActionTypes } from '../actions';
import { ResourceTypes } from '../party/resources/resources';
import { HistoryTypes } from '../party/history/history';
import Calendar from '../calendar';
import Debug from 'debug';
const debug = Debug('party:phases');

const Phases = startPhase => {
  let currentPhase = 0;

  const path = {
    name: 'path',
    initParty: () => {},
    locations: [Locations.Path.index],
    actions: [ActionTypes.Walk],
    cityActions: [],
    resources: [],
    calendar: Calendar.NONE
  };
  const city = {
    name: 'city',
    initParty: () => {},
    locations: [Locations.City.index],
    actions: [ActionTypes.Walk],
    cityActions: [],
    resources: [ResourceTypes.Health, ResourceTypes.Water],
    calendar: Calendar.DATE
  };
  const road = {
    name: 'road',
    initParty: () => {},
    locations: [Locations.Road.index, Locations.City.index],
    actions: [ActionTypes.Forage, ActionTypes.Hunt, ActionTypes.Rest, ActionTypes.Depart],
    cityActions: [
      CityActionTypes.Beg,
      CityActionTypes.Work,
      CityActionTypes.Rob,
      CityActionTypes.BuyMedicine,
      CityActionTypes.TradePost
    ],
    resources: [ResourceTypes.Health, ResourceTypes.Food, ResourceTypes.Coins],
    calendar: Calendar.FULL
  };
  const caravan = {
    initParty: () => {},
    locations: [Locations.Road.index, Locations.Party.index, Locations.City.index],
    actions: [],
    cityActions: [],
    resources: [],
    calendar: Calendar.FULL
  };

  const list = [path, city, road, caravan];

  const firstPhase = () => {
    return list[startPhase];
  };

  const nextPhase = () => {
    currentPhase = Math.min(currentPhase + 1, list.length - 1);
    return list[currentPhase];
  };

  const disable = (type, index) => {
    if (!list[currentPhase][type]?.includes(index)) return;

    list[currentPhase][type] = list[currentPhase][type].filter(res => {
      return res !== index;
    });
    debug('Disable', list[currentPhase][type]);
  };

  const disableAction = index => {
    disable('actions', index);
  };

  const enable = (type, index) => {
    if (list[currentPhase][type]?.includes(index)) return;

    debug('Enabling', type, index);
    list[currentPhase][type].push(index);
  };

  const enableResource = resourceIndex => {
    if (list[currentPhase].resources.includes(resourceIndex)) return;

    list[currentPhase].resources.push(resourceIndex);
  };

  const enableCalendar = setting => {
    list[currentPhase].calendar = setting;
  };

  const enableLocation = locationIndex => {
    enable('locations', locationIndex);
  };

  const disableLocation = locationIndex => {
    disable('locations', locationIndex);
  };

  const enableAction = actionIndex => {
    enable('actions', actionIndex);
  };

  const enableCityAction = index => {
    enable('cityActions', index);
  };

  const disableCityAction = index => {
    disable('cityActions', index);
  };

  // type = actions, cityActions, locations, resources
  // index = index of the type for example ActionTypes.Walk
  const isEnabled = (type, index) => {
    return list[currentPhase][type]?.includes(index);
  };

  const isCityActionEnabled = index => {
    return isEnabled('cityActions', index);
  };

  const isActionEnabled = index => {
    return isEnabled('actions', index);
  };

  const historyActionsListener = (action, total, successes, failures, _) => {
    if (action === CityActionTypes.ExamineMap && total === 1) {
      debug(action, total, successes, failures);
      disableCityAction(CityActionTypes.ExamineMap);
    }
  };

  const historyListener = (resIndex, _, newValue) => {
    switch (resIndex) {
      // The map is read at a tavern table and it hands off to the barkeep, so it is a town
      // affordance and belongs beside beg and work in the town's own column — not in the road
      // menu with walk and depart, where it used to sit adrift of the scene it opens.
      case HistoryTypes.RoadMap:
        enableCityAction(CityActionTypes.ExamineMap);
        break;
      default:
        break;
    }
  };

  const resourceListener = (resIndex, _, newValue, { party }) => {
    switch (resIndex) {
      case ResourceTypes.Health:
        break;

      case ResourceTypes.Food:
        // Resources should now be visible
        if (newValue > 0) enableResource(party.resources.attribs.food.index);
        break;

      case ResourceTypes.Water:
        // Resources should now be visible
        if (newValue > 0) enableResource(party.resources.attribs.water.index);
        break;

      case ResourceTypes.Coins:
        // Resources should now be visible
        if (newValue > 0) enableResource(party.resources.attribs.coins.index);
        break;

      case ResourceTypes.Ammo:
        // Resources should now be visible
        if (newValue > 0) enableResource(party.resources.attribs.ammo.index);
        break;
      case ResourceTypes.Horse:
        if (!newValue) {
          disableAction(ActionTypes.Depart);
        }
        break;
      default:
        debug('resourceListener: Not found', resIndex, newValue);
        break;
    }
  };

  return {
    list,
    firstPhase,
    nextPhase,
    enableResource,
    enableCalendar,
    enableAction,
    enableCityAction,
    enableLocation,
    disableLocation,
    resourceListener,
    historyListener,
    historyActionsListener,
    disableAction,
    disableCityAction,
    isCityActionEnabled,
    isActionEnabled
  };
};

export default Phases;
